import { TextField } from "@mui/material";
import { ChangeEvent } from "react";
import { FieldValues, useController, useFormContext } from "react-hook-form";

import { BaseFieldProps } from "./FieldProps";
import useIsFieldDisabled from "../../hooks/formHooks/useIsFieldDisabled";

type Props<TFieldValues extends FieldValues> = {
  rows: number;
  isRequired?: boolean;
} & BaseFieldProps<TFieldValues>;

const TextAreaField = <TFieldValues extends FieldValues>({
  name,
  label,
  rows,
  isRequired,
  disabled = false,
  disabledForEdit = false,
}: Props<TFieldValues>) => {
  const { control, clearErrors } = useFormContext<TFieldValues>();
  const { field, fieldState } = useController({
    name,
    control,
  });

  const errorMessage = fieldState.error?.message;
  const fieldIsDisabled = useIsFieldDisabled(disabled, disabledForEdit);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    field.onChange(event);
    clearErrors(name);
  };

  return (
    <TextField
      data-testid={`form-${label}-TEXTAREA`}
      {...field}
      onChange={handleChange}
      multiline
      label={label}
      rows={rows}
      error={!!errorMessage}
      helperText={errorMessage}
      disabled={fieldIsDisabled}
      required={isRequired}
    />
  );
};

export default TextAreaField;
